<div> 
    <mat-form-field class="input-full-width">
        <mat-label>Link Type:</mat-label>
        <mat-select [(ngModel)]="link.type" name="linktype">
            <mat-option [value]="RetailerLinkType.Website">
                Website
            </mat-option>
            <mat-option [value]="RetailerLinkType.Reservations">
              Online Reservations
            </mat-option>
            <mat-option [value]="RetailerLinkType.OnlineOrdering">
                Online Ordering
            </mat-option>            
            <mat-option [value]="RetailerLinkType.Facebook">
                Facebook
            </mat-option>
            <mat-option [value]="RetailerLinkType.Twitter">
                Twitter
            </mat-option>
            <mat-option [value]="RetailerLinkType.Instagram">
                Instagram
            </mat-option>
            <mat-option [value]="RetailerLinkType.Google">
                Google
            </mat-option>
            <mat-option [value]="RetailerLinkType.Other">
                Other
            </mat-option>
          </mat-select>
    </mat-form-field>
    <mat-form-field class="input-full-width" *ngIf="link.type == RetailerLinkType.Other">
        <mat-label>Description:</mat-label>
        <input matInput type="text" [(ngModel)]="link.name"  />
    </mat-form-field>
    <mat-form-field class="url-input">
        <mat-label>URL:</mat-label>
        <input matInput type="url" [(ngModel)]="link.url"  />
    </mat-form-field>
</div>
